/**
 * Nén ảnh trên trình duyệt trước khi gửi. Backend cũng nén bằng sharp, nhưng nén ở đây
 * tiết kiệm phần tốn nhất: ảnh 15MB không phải đi trọn vẹn qua đường truyền.
 * Tệp không phải ảnh được trả về nguyên vẹn.
 */

const TARGET_MAX_SIZE = 2 * 1024 * 1024;

const encodeCanvas = (canvas, outputType, quality) => {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) return reject(new Error('Canvas toBlob thất bại'));
        resolve(blob);
      },
      outputType,
      quality,
    );
  });
};

export const resizeImage = (file, options = {}) => {
  if (!file.type || !file.type.startsWith('image/')) {
    return Promise.resolve(file);
  }

  const {
    maxWidth = 2560,
    maxHeight = 2560,
    outputType = 'image/jpeg',
  } = options;

  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);

    img.onload = async () => {
      URL.revokeObjectURL(url);

      try {
        let { width, height } = img;

        if (width > maxWidth || height > maxHeight) {
          const ratio = Math.min(maxWidth / width, maxHeight / height);
          width = Math.round(width * ratio);
          height = Math.round(height * ratio);
        }

        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(img, 0, 0, width, height);

        let quality = 0.95;
        let blob = await encodeCanvas(canvas, outputType, quality);

        while (blob.size > TARGET_MAX_SIZE && quality > 0.5) {
          quality = Math.round((quality - 0.05) * 100) / 100;
          blob = await encodeCanvas(canvas, outputType, quality);
        }

        const resizedFile = new File([blob], file.name, {
          type: outputType,
          lastModified: Date.now(),
        });

        // Ảnh nhỏ/đã tối ưu có thể phình ra sau khi encode lại.
        resolve(resizedFile.size < file.size ? resizedFile : file);
      } catch (err) {
        reject(err);
      }
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error(`Không đọc được ảnh ${file.name}`));
    };

    img.src = url;
  });
};

/** Một tệp lỗi không được làm hỏng cả lượt chọn — giữ nguyên tệp gốc. */
export const resizeImages = (fileList, options = {}) => {
  return Promise.all(
    Array.from(fileList).map((file) =>
      resizeImage(file, options).catch(() => file),
    ),
  );
};
